module.exports = __webpack_public_path__ + "img/G_Art_Claw_R_1_1_5.4748b9c5.png";